import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-yellow text-white text-center">
      <h1 className="text-9xl font-extrabold tracking-wide">404</h1>
      <p className="text-2xl font-semibold mt-4">Oops! Page not found.</p>
      <p className="text-lg mt-2 max-w-lg">
        The page you are looking for doesn't exist or has been moved. Let's get you back home!
      </p>
      <button
        onClick={() => navigate("/")}
        className="mt-6 px-6 py-3 bg-white text-yellow font-bold rounded-lg shadow-lg hover:bg-gray-200 transition-all"
      >
        Go to Home
      </button>
      <div className="absolute bottom-10 text-gray-200 text-sm">
        <p>© {new Date().getFullYear()} Game Gems. All rights reserved.</p>
      </div>
    </div>
  );
};

export default NotFound;